// src/views/Reseller/ResellerLeads.js
import React,{useEffect,useState} from 'react';
import {db} from '../../firebase/firebase.js';
import {
  collection,
  doc,
  onSnapshot,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
  getDoc
} from 'firebase/firestore';
import {useAuth} from '../../auth/AuthContext';

export default function ResellerLeads(){
  const{user}=useAuth();
  const resellerId=user?.uid;

  const[businessId,setBusinessId]=useState(null);
  const[leads,setLeads]=useState([]);
  const[loading,setLoading]=useState(true);

  const[modalOpen,setModalOpen]=useState(false);
  const[editId,setEditId]=useState(null);

  const[form,setForm]=useState({
    name:'',
    phone:'',
    email:'',
    urgency:'',
    jobType:'',
    status:'new'
  });

  const field=(k)=> (e)=> setForm({...form,[k]:e.target.value});

  // Load businessId from reseller profile
  useEffect(()=>{
    if(!resellerId)return;

    const loadBusiness=async()=>{
      const ref=doc(db,'resellers',resellerId);
      const snap=await getDoc(ref);

      if(snap.exists()){
        setBusinessId(snap.data().businessId);
      }
    };

    loadBusiness();
  },[resellerId]);

  // Load reseller leads
  useEffect(()=>{
    if(!businessId || !resellerId)return;

    const ref=collection(
      db,
      `businesses/${businessId}/resellers/${resellerId}/leads`
    );

    const q=query(ref,orderBy("createdAt","desc"));

    const unsub=onSnapshot(q,(snap)=>{
      const arr=[];
      snap.forEach(d=> arr.push({id:d.id,...d.data()}));
      setLeads(arr);
      setLoading(false);
    });

    return()=>unsub();
  },[businessId,resellerId]);

  const openEdit=(lead)=>{
    setEditId(lead.id);
    setForm({
      name:lead.name||'',
      phone:lead.phone||'',
      email:lead.email||'',
      urgency:lead.urgency||'',
      jobType:lead.jobType||'',
      status:lead.status||'new'
    });
    setModalOpen(true);
  };

  const saveLead=async()=>{
    if(!businessId || !resellerId || !editId)return;

    const ref=doc(
      db,
      `businesses/${businessId}/resellers/${resellerId}/leads/${editId}`
    );

    await updateDoc(ref,form);
    setModalOpen(false);
  };

  const removeLead=async(id)=>{
    if(!businessId || !resellerId)return;

    const ref=doc(
      db,
      `businesses/${businessId}/resellers/${resellerId}/leads/${id}`
    );

    await deleteDoc(ref);
  };

  if(loading){
    return(
      <div className='w-full min-h-screen bg-gray-900 text-white flex justify-center items-center'>
        <h2>Loading leads…</h2>
      </div>
    );
  }

  return(
    <div className='w-full min-h-screen bg-gray-900 text-white p-6'>
      <h1 className='text-3xl font-semibold mb-6'>Reseller Leads</h1>

      <div className='bg-gray-800 rounded-xl p-5 shadow-lg overflow-x-auto'>
        <table className='w-full text-left'>
          <thead>
            <tr className='border-b border-gray-700'>
              <th className='py-2'>Name</th>
              <th className='py-2'>Phone</th>
              <th className='py-2'>Urgency</th>
              <th className='py-2'>Job Type</th>
              <th className='py-2'>Status</th>
              <th className='py-2'>Actions</th>
            </tr>
          </thead>

          <tbody>
            {leads.map((lead)=>(
              <tr key={lead.id} className='border-b border-gray-800'>
                <td className='py-2'>{lead.name||'N/A'}</td>
                <td className='py-2'>{lead.phone||'N/A'}</td>
                <td className='py-2'>{lead.urgency||'N/A'}</td>
                <td className='py-2'>{lead.jobType||'N/A'}</td>
                <td className='py-2 capitalize'>{lead.status||'new'}</td>

                <td className='py-2 flex gap-3'>
                  <button
                    onClick={()=>openEdit(lead)}
                    className='bg-yellow-600 hover:bg-yellow-700 px-3 py-1 rounded'
                  >
                    Edit
                  </button>

                  <button
                    onClick={()=>removeLead(lead.id)}
                    className='bg-red-600 hover:bg-red-700 px-3 py-1 rounded'
                  >
                    Delete
                  </button>
                </td>

              </tr>
            ))}
          </tbody>

        </table>
      </div>


      {/* Modal */}
      {modalOpen && (
        <div className='fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center'>
          <div className='bg-gray-800 p-6 rounded-xl w-full max-w-lg'>

            <h2 className='text-2xl font-semibold mb-4'>Edit Lead</h2>

            <div className='grid grid-cols-1 gap-4'>
              <input className='p-2 rounded bg-gray-700' placeholder='Name' value={form.name} onChange={field('name')}/>
              <input className='p-2 rounded bg-gray-700' placeholder='Email' value={form.email} onChange={field('email')}/>
              <input className='p-2 rounded bg-gray-700' placeholder='Phone' value={form.phone} onChange={field('phone')}/>
              <input className='p-2 rounded bg-gray-700' placeholder='Urgency' value={form.urgency} onChange={field('urgency')}/>
              <input className='p-2 rounded bg-gray-700' placeholder='Job Type' value={form.jobType} onChange={field('jobType')}/>

              <select className='p-2 rounded bg-gray-700' value={form.status} onChange={field('status')}>
                <option value='new'>New</option>
                <option value='contacted'>Contacted</option>
                <option value='in-progress'>In Progress</option>
                <option value='completed'>Completed</option>
              </select>
            </div>

            <div className='flex justify-end gap-4 mt-6'>
              <button
                onClick={()=>setModalOpen(false)}
                className='px-4 py-2 bg-gray-600 rounded'
              >
                Cancel
              </button>

              <button
                onClick={saveLead}
                className='px-4 py-2 bg-blue-600 rounded'
              >
                Save
              </button>
            </div>

          </div>
        </div>
      )}

    </div>
  );
}
